<template>
    <div class="card-container">
        <div class="flex-row vertical-center flow-justify">
            <el-button type="default" class="button-size" @click="$router.go(-1)">返回上一级</el-button>
        </div>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column prop="tatName" label="应用图标" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    <div class="flex-row vertical-stretch flow-center">
                        <el-image :src="scope.row.iconUrl" fit="cover"  class="appIcon">
                            <div slot="error" class="image-slot">
                                <el-image :src="require('../../../assets/images/' + (scope.row.os == 1 ? 'IOS' : 'Android') + '.jpg')" fit="cover"></el-image>
                            </div>
                        </el-image>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="versionNum" label="版本" min-width="130" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{scope.row.versionNum}}（{{scope.row.buildNum}}）</p>
                </template>
            </el-table-column>
            <el-table-column prop="forceUpdate" label="更新机制" min-width="100" :formatter="formatTranTypee" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="状态" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{scope.row.status == 1 ? '开启' : '禁用'}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="versionDes" label="版本描述" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="editTime" label="更新时间" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tatSimpleName" label="操作" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button type="text" @click="handleDetail(scope.row)">下载</el-button>
                    <el-button type="text" @click="changeInfo2(scope.row)">{{scope.row.status == 0 ? '开启' : '禁用'}}</el-button>
                    <!--<el-button type="text" @click="changeInfo(scope.row.id)">修改</el-button>-->
                </template>
            </el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTable from 'components/common/CommonTable'

    import privateKey from 'service/constant/privateKey'
    import Server from 'common/conf/Server';
    import OrganService from 'service/OrganService'
    import APPService from 'service/APPService'
    import forceUpdatesTypes from 'service/constant/forceUpdatesTypes'
    import Regs from "common/conf/Regs";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "AppAreaDetail",
        components: {
            CommonTable
        },
        data() {
            return {
                commonUrl: '8883/tatApp/download/',
                uploadUrl: Server[process.env.NODE_ENV],
                tatSimpleNames: [],
                topTatSimpleNames: [],
                tableData: [],
                page: {},
                isPage: false,
            }
        },
        mixins: [loadMixin, dialogMixin],
        computed: {
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        mounted() {
            this.page = this.$refs.commonTable.page;
            // this.getSimpleNames();
            this.getList();
        },
        methods: {
            formatTranTypee(row, column, cellValue) {
                let value = '';
                forceUpdatesTypes.forEach(item => {
                    if (item.id == cellValue) {
                        value = item.label
                    }
                });
                return value ? value : '--'
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(APPService.detailList, {
                    tatSimpleId: this.$route.params.tatSimpleId,
                    os: this.$route.params.os
                }, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.tableData = result.records;
                        this.tableData.forEach(item => {
                            if (item.id && item.tatAbbr){
                                item.iconUrl = this.uploadUrl + this.commonUrl + item.tatAbbr + '/' + item.id + '.png'
                            }
                        });
                        this.page.currentPage = result.current;
                        this.page.total = result.total;
                        this.page.pageSize = result.size;
                        this.isPage = false;
                    })
                }, '信息获取失败')
            },
            getSimpleNames() {
                this.doLoad(OrganService.simpleNames, '', res => {
                    this.doCheck(res, res => {
                        this.tatSimpleNames = res.contents;
                        this.topTatSimpleNames = [...this.allTat, ...res.contents];
                    });
                }, '信息获取失败')
            },
            changeInfo() {
                this.$router.push({
                    name: 'appupload'
                })
            },
            changeInfo2(item) {
                this.showConfirm(`确定${item.status == 0 ? '开启' : '禁用'}此机构吗`).then(() => {
                    this.doChangeInfo(item)
                }).catch(() => {
                });
            },
            doChangeInfo(item){
                const params = {
                    id:item.id,
                    status: item.status == 0 ? 1 : 0,
                };
                this.doLoad(APPService.edit, params, res => {
                    this.doCheck(res, res => {
                        this.getList();
                        this.showSuccess(res.respMsg)
                    });
                }, '信息获取失败')
            },
            handleDetail(item) {
                window.open(this.uploadUrl + this.commonUrl + item.tatAbbr + '/' + item.id + (item.os == 0 ? '.apk' : '.ipa'));
            },
        },
    }
</script>

<style scoped>
    .appIcon {
        width: 50px;
        height: 50px;
        margin: 10px;
        border: 1px solid #E6E6E6;
        border-radius: 10px;
    }
    .button-size {
        width: 120px;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/AppAreaDetail.vue